module.exports = __webpack_public_path__ + "assets/google-cloud.d1b82dc1.svg";